import { toastr } from "react-redux-toastr";

const nextId = () =>
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;


export default class Notification {
  constructor(type, message) {
    this.type = type || "info";
    this.message = message || "";
    this.title = "";
    this.options = {};
    this.id = nextId();
  }
  setType(type) {
    this.type = type;
    return this;
  }

  setTitle(title) {
    this.title = title;
    return this;
  }

  setMessage(message) {
    this.message = message;
    return this;
  }

  setOptions(options) {
    this.options = options;
    return this;
  }

  send() {
    // ----- default title shortcuts -----
    if (this.type === 'success' && !this.title) this.title = 'Success';
    if (this.type === 'error'   && !this.title) this.title = 'Failure';

    // ----- basic validation -----
    if (
      !['info', 'warning', 'error', 'success'].includes(this.type) ||
      (!this.title && !this.message)
    ) return;

    // ----- optional global clear (rarely needed) -----
    if (this.options.clearExisting) toastr.clean();

    // ----- fire the toast -----
    toastr[this.type](this.title, this.message, {
      ...this.options,
      toastrId: this.id,          // makes it a *new* toast, not a replacement
    });
  }
}
